import { memo } from 'react';

import './NoStatuses.scss';

const NoStatuses = () => (
  <div className="data-science__pipeline-creator__body__workspace__diagram__status-box__container__no-results">
    <p>The task has no connected statuses.</p>
  </div>
)

export default memo(NoStatuses);